import { Slide } from "../../../../components/LeadWall/types";

export const personalResultsSlide: Slide = {
  title: "Persönliche Ergebnisseite",
  subTitle: "700+ Banken vergleichen",
  lottie: "/assets/img/lead-wall-slide-1.json",
  color: "cadet",
};

export const interestRateAlarmSlide: Slide = {
  title: "Zins-Update",
  subTitle: "Regelmäßig informiert bleiben",
  image: "/assets/img/lead-wall-slide-2.png",
  mobileImage: "/assets/img/lead-wall-slide-2-mobile.png",
  color: "marigold",
};

export const certificateSlide: Slide = {
  title: "Finanzierungszertifikat",
  subTitle: "Vorteil als Käufer sichern",
  image:
    "https://cdn.justhome.com/cdn/assets/lead_wall_slide_3_e3df8561e5.png?1",
  mobileImage:
    "https://cdn.justhome.com/cdn/assets/lead_wall_slide_3_e3df8561e5.png?w=510",
  color: "primary",
  imageFull: true,
  imageClass: "object-contain object-bottom",
};

export const consultationSlide: Slide = {
  title: "Persönlicher Berater",
  subTitle: "Auf Wunsch kostenfrei beraten",
  image: "/assets/img/lead-wall-slide-4.png",
  mobileImage: "/assets/img/lead-wall-slide-4-mobile.png",
  color: "purple",
};
